import { useMemo } from "react";
import { ShareConfig } from "./config";
import {
  FacebookShareButton,
  OKShareButton,
  PinterestShareButton,
  TelegramShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  MailruShareButton,
} from "react-share";
import {
  FacebookIcon,
  OKIcon,
  PinterestIcon,
  TelegramIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WhatsappIcon,
  MailruIcon,
} from "react-share";
import type { TShareProps } from "./typings";
import { isDefined } from "@/utils/is-defined";

export const useShareProviders = ({
  title,
  picture,
  excerpt,
  link,
}: TShareProps) => {
  return useMemo(() => {
    const commonShareProps = {
      title,
      url: link,
    };
    return [
      <FacebookShareButton aria-label="Facebook" key="fb" {...commonShareProps}>
        <FacebookIcon aria-hidden size={ShareConfig.btnSize} round />
      </FacebookShareButton>,
      <OKShareButton
        key="ok"
        description={excerpt}
        image={picture}
        aria-label="Одноклассники"
        {...commonShareProps}
      >
        <OKIcon aria-hidden size={ShareConfig.btnSize} round />
      </OKShareButton>,
      <VKShareButton
        aria-label="Vkontakte"
        key="vk"
        image={picture}
        {...commonShareProps}
      >
        <VKIcon aria-hidden size={ShareConfig.btnSize} round />
      </VKShareButton>,
      <WhatsappShareButton aria-label="Whatsapp" key="wa" {...commonShareProps}>
        <WhatsappIcon aria-hidden size={ShareConfig.btnSize} round />
      </WhatsappShareButton>,
      picture ? (
        <PinterestShareButton
          aria-label="Pinterest"
          key="pinterest"
          description={excerpt}
          media={picture}
          {...commonShareProps}
        >
          <PinterestIcon aria-hidden size={ShareConfig.btnSize} round />
        </PinterestShareButton>
      ) : undefined,
      <TelegramShareButton aria-label="Telegram" key="tg" {...commonShareProps}>
        <TelegramIcon aria-hidden size={ShareConfig.btnSize} round />
      </TelegramShareButton>,
      <ViberShareButton aria-label="Viber" key="viber" {...commonShareProps}>
        <ViberIcon aria-hidden size={ShareConfig.btnSize} round />
      </ViberShareButton>,
      <TwitterShareButton
        aria-label="Twitter"
        key="twitter"
        {...commonShareProps}
      >
        <TwitterIcon aria-hidden size={ShareConfig.btnSize} round />
      </TwitterShareButton>,
      <MailruShareButton
        key="mailru"
        description={excerpt}
        imageUrl={picture}
        aria-label="Mail.ru"
        {...commonShareProps}
      >
        <MailruIcon aria-hidden size={ShareConfig.btnSize} round />
      </MailruShareButton>,
    ].filter(isDefined);
  }, [title, picture, excerpt, link]);
};
